<div class="ya-typography" (swiperight)="swiperNavigateBack()">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div [@serviceButtonEntering]="isLoaded"
    class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <ng-container *ngIf="groupSummary then summaryTemplate else emptyTemplate"></ng-container>
    <ng-template #summaryTemplate>
      <div class="title-container title-margin">
        <h2><span class="title-text-size">{{GetGroupNameText(groupSummary.groupName)}}</span></h2>
      </div>
      <div class="group-info-content">
        <div class="group-info-wrap animate">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="hypersoft-remote-group.svg">
            </div>
          </div>
          <ng-container *ngIf="stateFinished(groupSummary.status)">
            <div class="title-container">
              <span class="info-label" langkey="phRemoteOrder_Group_Summary_Status"></span>
            </div>
          </ng-container>
          <div class="title-container description-margin">
            <ng-container
              *ngIf="isOrderDelivery(groupSummary.preOrdervariant) then DeliveryTemplate else PickUpTemplate"></ng-container>
            <ng-template #DeliveryTemplate>
              <div class="info-content">
                <span class="info-label" [innerHTML]="setDeliveryEndTime(groupSummary.serviceTime)"></span>
              </div>
              <div class="info-content__address">
                <ng-container *ngIf="groupSummary.deliveryAddress"> <span class="info-label info--left"
                    [innerHTML]="setDeliveryGroupAddress(groupSummary.deliveryAddress)"></span></ng-container>
                <ng-container *ngIf="locationData">
                  <span class="info-label" [innerHTML]="setDeliveryLocationName(locationData.name)"></span>
                </ng-container>
              </div>
            </ng-template>
            <ng-template #PickUpTemplate>
              <div class="info-content">
                <span class="info-label" [innerHTML]="setPickupEndTime(groupSummary.serviceTime)"></span>
              </div>
              <div class="info-content__address">
                <span class="info-label" langkey="phRemoteOrder_Group_Summary_Pickup_Address"></span>
                <ng-container *ngIf="locationData">
                  <span class="info-label info--top emphasized ">{{locationData.street}}, {{locationData.zipCode + " "
                    +locationData.city}}</span>
                </ng-container>
              </div>

            </ng-template>
          </div>
          <ng-container
            *ngIf="groupSummary.count && groupSummary.count>0 && groupSummary.price && groupSummary.price>0">
            <div class="title-container description-margin">
              <span langkey="phRemoteOrder_Group_Summary_Basket_Title"></span>:
              <p>
                <span class="count">{{groupSummary.count}}</span>
                <span class="middle-text" langkey="phRemoteOrder_Group_Summary_Basket"></span>
                <span class="price">{{formatCurrency(groupSummary.price)}}</span>
              </p>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ng-template #emptyTemplate>
        <ya-emptypage></ya-emptypage>
      </ng-template>
    </ng-template>
  </div>
</div>